module.exports = __webpack_public_path__ + "img/libros.b9ceb023.png";